// @flow
/* eslint-disable no-unused-vars */
import * as wjcCore from 'wijmo/wijmo';

import { createColumnOrRowFormatter } from '../../../utils';
import type { FormatterArgs } from '../../../types';

const formatter = (args: FormatterArgs) =>
  createColumnOrRowFormatter({
    columnName: 'RstApp',
    formatStyle: 'row', // can be wheter 'row' or 'cell'.
    formatter: ({ elem, dataItem }) => {
      const item = dataItem;
      let color;

      if (item.RstApp && item.RstApp.trim() !== '') {
        color = 'yellow';
      }

      if (!color) return;

      wjcCore.addClass(elem.cell, color);
    },
  });

export default formatter;
